import React, { useState } from "react";
import { useSelector } from "react-redux";

import StatisticWidget from "../../components/shared-components/StatisticWidget";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import "./Flights.scss";

import { canCancelBookings } from "../../utils/roles";
import { useFlightBookings } from "./lib/useFlightBookings";
import BookingsTable from "./components/BookingsTable";
import BookingDetailDrawer from "./components/BookingDetailDrawer";
import CancelBookingModal from "./components/CancelBookingModal";
import IssueTicketModal from "./components/IssueTicketModal";

const Flights = () => {
  const { admin } = useSelector((state) => state.auth);
  const {
    activeTab,
    setActiveTab,
    page,
    setPage,
    pageSize,
    searchInput,
    setSearchInput,
    data,
    loading,
    summary,
    refetch,
  } = useFlightBookings();

  const [detailBooking, setDetailBooking] = useState(null);
  const [issueBooking, setIssueBooking] = useState(null);
  const [cancelBooking, setCancelBooking] = useState(null);
  const [cancelIsRetry, setCancelIsRetry] = useState(false);

  const handleCancel = (record) => {
    const state = record?.cancellation?.state;
    setCancelIsRetry(state === "FAILED" || state === "PENDING_PROVIDER");
    setCancelBooking(record);
  };

  return (
    <div className="home">
      <Sidebar />
      <div className="homeContainer">
        <Navbar />

        <IssueTicketModal
          open={Boolean(issueBooking)}
          booking={issueBooking}
          onClose={() => setIssueBooking(null)}
          onSuccess={refetch}
        />

        <BookingDetailDrawer
          open={Boolean(detailBooking)}
          booking={detailBooking}
          onClose={() => setDetailBooking(null)}
        />

        <CancelBookingModal
          open={Boolean(cancelBooking)}
          booking={cancelBooking}
          admin={admin}
          retry={cancelIsRetry}
          onClose={() => setCancelBooking(null)}
          onSuccess={() => {
            setCancelBooking(null);
            refetch();
          }}
        />

        <div className="widgets">
          <div className="statTile">
            <StatisticWidget
              title="Total Bookings"
              value={`${summary?.all ?? 0}`}
              subtitle="Total flight bookings"
              isLoading={loading}
            />
          </div>
        </div>

        <BookingsTable
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          searchInput={searchInput}
          setSearchInput={setSearchInput}
          data={data}
          loading={loading}
          summary={summary}
          canCancel={canCancelBookings(admin)}
          onView={setDetailBooking}
          onIssue={setIssueBooking}
          onCancel={handleCancel}
        />
      </div>
    </div>
  );
};

export default Flights;
